// const baseurl = "http://103.186.185.77:5033/camarketing/adminportal/"
//https://api.hasinienterprises.co.in
// http://193.203.160.181:5046
// export const baseurl = "https://api.hasinienterprises.co.in/v1/hasiniapi/admin/"

export const baseurl = "https://api.hasinienterprises.co.in/v1/hasiniapi/admin/"
export const baseurlweb = "https://api.hasinienterprises.co.in/v1/hasiniapi/web/"
export const imgUrl = "https://api.hasinienterprises.co.in/"
